import React from "react";

export const en = {
  body: (
    <div>
      <h3>Pladias</h3>
      <p>
        Pladias (Centre for Analysis and Synthesis of Plant Diversity) was a project funded by the
        Czech Science Foundation in 2014–2018. This project was coordinated by Milan Chytrý from the
        Vegetation Science Group and it involved several dozen botanists from the Department of
        Botany and Zoology, Faculty of Science, Masaryk University, Institute of Botany of the Czech
        Academy of Sciences, University of South Bohemia in České Budějovice and many external
        collaborators.
      </p>
      <p>
        As a supporting infrastructure for the Pladias research project, an extensive database of
        critically revised data on Czech flora and vegetation was established and made accessible to
        the professional and general public on the website{" "}
        <a href="https://pladias.cz/">https://pladias.cz/</a>. It is continuously updated even after
        the end of the Pladias project. The database is focused on native and spontaneously
        established flora found in the Czech Republic, not on cultivated plants, although the most
        common cultivated crops and planted exotic trees are included. The vegetation part of the
        database summarizes, in an online version, the content of the monograph Vegetation of the
        Czech Republic.
      </p>
    </div>
  )
};

export const cz = {
  body: (
    <div>
      <h3>Pladias</h3>
      <p>
        Pladias (Plant Diversity Analysis and Synthesis Centre) byl projekt financovaný Grantovou
        agenturou České republiky v letech 2014–2018. Projekt řídil Milan Chytrý z pracovní skupiny
        Výzkum vegetace a účastnilo se jej několik desítek botaniků z Ústavu botaniky a zoologie PřF
        MU, Botanického ústavu AV ČR, Jihočeské univerzity v Českých Budějovicích a řada externích
        spolupracovníků.
      </p>
      <p>
        Jako podpůrná infrastruktura pro výzkum projektu Pladias byla vytvořena rozsáhlá databáze
        kriticky revidovaných údajů o české flóře a vegetaci, která byla zpřístupněna odborné i
        laické veřejnosti na portálu <a href="https://pladias.cz/">https://pladias.cz/</a> a je
        průběžně doplňována i po ukončení projektu Pladias. Databáze je zaměřena na planou nebo
        zplanělou flóru vyskytující se na území České republiky, nikoliv na rostliny pěstované, i
        když nejběžnější pěstované plodiny a vysazované exotické dřeviny zahrnuty jsou. Část
        věnovaná vegetaci shrnuje v online verzi obsah monografie Vegetace České republiky.
      </p>
    </div>
  )
};
